/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { Button } from 'antd';
import './animation045.less';

import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowRight from '../../../../../assets/arrow-right.png';
import ImgArrowLeft from '../../../../../assets/arrow-left.png';

interface IAnimation045Props {
  img1: string;
  img2: string;
  text1: string;
  text2: string;
  content: string;
  className: string;
  onCompleted?: () => void;
}

const Animation045: React.FunctionComponent<IAnimation045Props> = ({
  img1,
  img2,
  text1,
  text2,
  content,
  className,
  onCompleted,
}) => {
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  const [state, setState] = React.useState({
    step: 1,
    completed: false,
    secureWarning: 1,
    secureWarningCompleted: false,
  });
  const swithSecureWarning = (step: number) => {
    setState({
      ...state,
      secureWarning: state.secureWarning + step,
      secureWarningCompleted: true,
    });
    if (state.secureWarning >= 1) {
      onCompleted && onCompleted();
    }
  };
  return (
    <div className={`secure-warning-section component ${className}`}>
      <div className="secure-warning-section-left">
        <Button
          className={`prev-button ${state.secureWarning === 1 ? 'hide' : ''}`}
          type="text"
          onClick={() => swithSecureWarning(-1)}
        >
          <img src={ImgArrowLeft} alt="" />
        </Button>
        <div
          className={`secure-warning secure-warning-1 ${
            state.secureWarning !== 1 ? 'hide' : ''
          }`}
        >
          <img src={getImg(img1)} alt="" />
          <div className="text">{text1}</div>
        </div>
        <div
          className={`secure-warning secure-warning-2 ${
            state.secureWarning !== 2 ? 'hide' : ''
          }`}
        >
          <img src={getImg(img2)} alt="" />
          <div className="text">{text2}</div>
        </div>
        {state.secureWarningCompleted || (
          <img className="point" src={ImgPoint} alt="" />
        )}
        <Button
          className={`next-button ${state.secureWarning === 2 ? 'hide' : ''}`}
          type="text"
          onClick={() => swithSecureWarning(1)}
        >
          <img src={ImgArrowRight} alt="" />
        </Button>
      </div>
      <div className="secure-warning-section-right">
        <div
          className="secure-warning-board"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default Animation045;
